import { render, staticRenderFns } from "./AddTasks.vue?vue&type=template&id=5200736d"
import script from "./AddTasks.vue?vue&type=script&lang=js"
export * from "./AddTasks.vue?vue&type=script&lang=js"
import style0 from "./AddTasks.vue?vue&type=style&index=0&id=5200736d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports